import { HOST, PORT } from '../../environment';

/** Resolve port numbers for startMany: all ports on device, or current port only. */
export async function resolveStartManyPorts(station, stationNumber) {
  const deviceId = station?.deviceId;
  if (deviceId) {
    try {
      const res = await fetch(
        `${HOST}:${PORT}/api/device/v2/ports-by-device?device_id=${encodeURIComponent(deviceId)}`
      );
      if (res.ok) {
        const data = await res.json();
        const ports = data?.portNumbers || [];
        if (ports.length > 0) {
          return ports;
        }
      }
    } catch (err) {
      console.error('ports-by-device lookup failed', err);
    }
  }
  return stationNumber != null && stationNumber !== '' ? [String(stationNumber)] : [];
}

/** Navigate to /startMany for all ports on the station device. */
export async function openStartManyForStation(navigate, station, stationNumber) {
  const ports = await resolveStartManyPorts(station, stationNumber);
  if (ports.length === 0) {
    return;
  }
  navigate(`/startMany?ports=${ports.join(',')}`);
}
